<template>
    <div>
        <b-modal id="videoModel" hide-footer>
            <iframe id="videoFrame" :src="videoSrc" width="100%" height="480" frameborder="0"
                webkitallowfullscreen="" mozallowfullscreen=""></iframe>
        </b-modal>
        <div class="material-list video">
            <h4>{{ data.title }}</h4>
            <div class="row">
                <div class="col-md-6">
                    <ul>
                        <li v-for="video in data.video" :key="video.id" >
                            <a class="videomodal" @click.prevent="videoModelShow(video.link)">
                                {{ video.name }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VideoBox',
    props: {
        // Define the prop name and type
        videoData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            videoSrc:"",
            data: {}
        }
    },
    methods:{
        videoModelShow(src){
           this.videoSrc = 'https://player.vimeo.com/video/' + src;
           this.$bvModal.show('videoModel');
        }
    },
    watch: {
        videoData: {
            immediate: true, // Execute the handler immediately on mount
            handler(newData) {
                this.data = newData;
            }
        }
    }
}
</script>